export default "__VITE_ASSET__CyPGXov6__"